import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {TaskService} from '../../../services/task.service';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {UserService} from '../../../services/user.service';
import {Globals} from '../../../globals';
import {TaskManagementDetailDialogModel} from '../task-management-dialog/task-management-dialog.component';
import {TaskUserGroupSelectionDialogComponent} from '../task-user-group-selection-dialog/task-user-group-selection-dialog.component';
import {TaskUserSelectionDialogComponent} from '../task-user-selection-dialog/task-user-selection-dialog.component';
import {MatSelectModule} from '@angular/material/select';

@Component({
  selector: 'app-task-detail-dialog',
  templateUrl: './task-detail-dialog.component.html', 
  styleUrls: ['./task-detail-dialog.component.scss']
})
export class TaskDetailDialogComponent implements OnInit {
  userTaskTypeEnums: EnumValidValueItemModel[] = [];
  taskStatusEnums: EnumValidValueItemModel[] = [];
  taskPriorityEnums: EnumValidValueItemModel[] = [];

  /*users: TdoUserConfigurationModel[];
  userGroups: TdoUserGroupConfigurationModel[];*/
  subjectEnums: EnumValidValueItemModel[];

  constructor(private dialogRef: MatDialogRef<TaskDetailDialogComponent>,
              private globals: Globals,
              private userService: UserService,
              private staticDataService: StaticDataService,
              private taskService: TaskService,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: TaskManagementDetailDialogModel) { }

  ngOnInit(): void {
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    } else {
      this.setupEnums();
    }

    /*this.userService.getUsers(this.globals.TDOCID).subscribe((users) => {
      this.users = users;

      this.userService.getUserGroups(parseInt(this.globals.TDOCID)).subscribe((groupsRes) => {
        this.userGroups = groupsRes;
      });
      // this.currentUser = this.users.find(p => p.UserID === this.localStorageService.currentUserData.authdata.userid);
    });*/
  }

  setupEnums() {
    this.userTaskTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumUserTaskType');
    this.taskStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumTaskStatus');
    this.taskPriorityEnums = this.staticDataService.getValidValueItemsByValidValueName('enumTaskPriority');

    if (this.data.model.isSystem) {
      this.subjectEnums = this.staticDataService.getValidValueItemsByValidValueName('enumSystemTaskType');
    } else {
      this.subjectEnums = this.staticDataService.getValidValueItemsByValidValueName('enumUserTaskType');
    }
  }

  getUserTaskType(enumId: string) {
    if (this.userTaskTypeEnums) {
      const type = this.userTaskTypeEnums.find(p => p.ValidValueItemId === enumId);
      if (type) {
        return type;
      }
    }
    return '';
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.save();
  }

  save(doClose = true) {
    this.taskService.saveTask(this.data.model).subscribe((res) => {
      if (doClose) {
        this.dialogRef.close(res);
      }
    });
  }

  onDateChange(event: MatDatepickerInputEvent<any, any>) {
    this.data.model.DueDate = new Date(event.value);
  }

  onUserTaskTypeChange(event: any) {
    this.data.model.enumUserTaskTypeID = event.value.ValidValueItemId;
  }

  getPriority(enumTaskPriorityID: string) {
    if (this.taskPriorityEnums) {
      const pri = this.taskPriorityEnums.find(p => p.ValidValueItemId === enumTaskPriorityID);
      return pri;
    }

    return null;
  }

  onUserPriorityChange(event: any) {
    this.data.model.enumTaskPriorityID = event.value.ValidValueItemId;
  }

  getStatus(id: string) {
    if (this.taskStatusEnums) {
      const stat = this.taskStatusEnums.find(p => p.ValidValueItemId === id);
      return stat;
    }

    return null;
  }

  onStatusChange(event: any) {
    this.data.model.enumTaskStatusID = event.value.ValidValueItemId;
  }

  getUser(userId: string) {
    if (this.data.users) {
      const user = this.data.users.find(p => p.UserID === userId);
      if (user) {
        return user.UserName;
      }
    }

    return '';
  }

  getDate(dateString: Date) {
    const date = new Date(dateString);
    if (date) {
      return date.toLocaleString();
    }

    return '';
  }

  onSubjectChange(event: any[]) {
    console.log('event: ' + event);
    this.data.model.ContentParametersJSON = JSON.stringify(event);
  }

  getUserGroupName(ForUserGroupID: string) {
    const gr = this.data.userGroups.find(p => p.UserGroupId === ForUserGroupID);
    if (gr) {
      return gr.UserGroupName;
    } else {
      return '';
    }
  }

  getSelectedSubjects() {

    
    var z : string[] = [];
    var s : any ;
    try {
    
      z=JSON.parse(this.data.model.ContentParametersJSON) as string[];
      s=JSON.parse(this.data.model.ContentParametersJSON);

      


    }
    catch(e) {
      console.log(e, "ContentParametersJSON: ",this.data.model.ContentParametersJSON);
      z.push(this.data.model.ContentParametersJSON);
    }

    console.log("z:" , z, s);

    return JSON.stringify(s, null, 2);
  }

  onUserGroupClick() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = this.data;
    this.dialog.open(TaskUserGroupSelectionDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.data.model.ForUserGroupID = res;
        this.save(false);
      }
    });
  }

  openUserSelectionDialog(isAssignToUserDialog: boolean) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    this.data.isAssignToUserDialog = isAssignToUserDialog;
    config.data = this.data;
    this.dialog.open(TaskUserSelectionDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        if (isAssignToUserDialog) {
          this.data.model.AssignedToUserID = res;
        } else {
          this.data.model.ForUserID = res;
          this.data.model.AssignedToUserID = res;
        }
      }

      this.save(false);
    });
  }

  onOpenSelectUser() {
    this.openUserSelectionDialog(false);
  }

  onOpenAssignUser() {
    this.openUserSelectionDialog(true);
  }

  getUserName(userID: string) {
    const user = this.data.users.find(p => p.UserID === userID);
    if (user) {
      return user.UserName;
    } else {
      return '';
    }
  }

  clearUsers() {
    this.data.model.ForUserID = null;
    this.data.model.AssignedToUserID = null;
    this.save(false);
  }
}
